const escapeHtml = (value: string) =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

const escapeAttribute = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

const sanitizeTag = (tag: string) => {
  if (/^<\s*br\s*\/?\s*>$/i.test(tag)) {
    return '<br>'
  }

  const simpleTag = tag.match(/^<\s*(\/?)\s*(strong|b|em|i)\s*>$/i)
  if (simpleTag) {
    return `<${simpleTag[1]}${simpleTag[2].toLowerCase()}>`
  }

  const plainSpanTag = tag.match(/^<\s*(\/?)\s*span\s*>$/i)
  if (plainSpanTag) {
    return `<${plainSpanTag[1]}span>`
  }

  const spanTag = tag.match(
    /^<\s*span\s+style\s*=\s*(?:"([^"]*)"|'([^']*)')\s*>$/i
  )
  if (spanTag) {
    const style = spanTag[1] ?? spanTag[2] ?? ''
    return `<span style="${escapeAttribute(style)}">`
  }

  return escapeHtml(tag)
}

export const sanitizeHeroSloganHtml = (value: string) => {
  let result = ''
  let lastIndex = 0

  value.replace(/<!--[\s\S]*?-->|<[^>]*>/g, (tag, offset: number) => {
    result += escapeHtml(value.slice(lastIndex, offset)).replace(
      /\r?\n/g,
      '<br>'
    )
    result += sanitizeTag(tag)
    lastIndex = offset + tag.length
    return tag
  })

  result += escapeHtml(value.slice(lastIndex)).replace(/\r?\n/g, '<br>')
  return result
}
